export default "__VITE_ASSET__Bs37YY$l__"